import React, { useContext, useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import ShopSearch from "../../../flone/components/product/ShopSearch";
import ShopCategories from "./ShopCategories";
import ShopSearchHistory from "./ShopSearchHistory";
import ShopCategoryDescription from "./ShopCategoryDescription";
import ShopGridStandardViewModel from "../viewModel";

const ShopSidebar = ({
  sideSpaceClass,
  onSearch,
  searchKeyword,
  // merchants,
  selectedKey,
}) => {
  const { categories, selectedCategory } = useContext(
    ShopGridStandardViewModel.Context
  );

  return (
    <div className={`sidebar-style ${sideSpaceClass || ""}`}>
      <ShopSearch onSearch={onSearch} searchKeyword={searchKeyword} />
      <ShopCategoryDescription selectedCategory={selectedCategory} />
      <ShopSearchHistory />
      <ShopCategories categories={categories} />
      {/* <ShopBrands merchants={merchants} /> */}
    </div>
  );
};

export default ShopSidebar;
